import axios from 'axios';

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1/',
    headers: { 'content-type': 'application/json' },
});

// language is read per request so switching language works without a reload
axiosClient.interceptors.request.use((config) => {
    config.headers.lang = localStorage.getItem('language') || 'vi';
    return config;
});

axiosClient.interceptors.response.use(
    (response) => (response && response.data ? response.data : response),
    (error) => Promise.reject(error),
);

export default axiosClient;
